

export class StrackerUtils {

    /**
     * 
     * @param seconds 
     * get the time in seconds
     * @returns
     * transforms the seconds into hh:mm:ss format (string)
     */
    static transormSeconds(seconds: number): string {
        let dur = Math.abs(seconds);
        let result = "";
        let h = 0;
        let m = 0;

        if (dur >= 60) {
            m = Math.floor(dur / 60);
        }
        if (m >= 60) {
            h = Math.floor(m / 60);
        }

        result = (h < 10) ? "0" + h + ":" : h + ":";
        result += ((m % 60) < 10) ? "0" + m % 60 + ":" : (m > 59) ? (m % 60) + ":" : m + ":";
        result += ((dur % 60) < 10) ? "0" + (dur % 60) : (dur > 59) ? (dur % 60) : dur + "";

        return result;
    }

}